<template>
  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Network Sales History</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">Country</th>
              <th class="min-w-225px">Product</th>
              <th class="min-w-200px">Sales Count</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{item.location}}</td>
                <td>{{item.product_desc}}</td>
                <td>{{item.salescount}}</td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
  </div>
  <!--end::Tables Widget 11-->

 
</template>

<script lang="ts">
import { defineComponent } from "vue";
import pagination from 'vue-bootstrap-pagination'
import {networksaleshistory}  from "@/api/networksales";


export default defineComponent({
  name: "networksaleshistory", 
  methods: {
    async networksaleshistory(){ 
      const response = await networksaleshistory(1);
       this.list = response.data.downlinesSales;
      console.log(response);
    },
    
  },
  mounted(){
      this.networksaleshistory();
  },
  data(){
      return { 
          list : []
      }
  }, 
  components: {
  },
  props: {
    widgetClasses: String
  }
});
</script>
